import React from 'react';
import { ScheduleDashboard } from '~/features/scheduling/dashboard/tabs/ScheduleDashboard';
import { EvvCompliance } from '~/features/visits/evv/EvvCompliance';
import { NeedsAssigned } from '~/features/scheduling/needs-assigned/NeedsAssigned';
import type { DuroRouteObject } from '~/shared/routing/types';

const SchedulingPage = React.lazy(() => import('./SchedulingPage').then(m => ({ default: m.SchedulingPage })));

export const routes: DuroRouteObject = {
	path: '/scheduling',
	children: [
		{
			element: <SchedulingPage />,
			children: [
				{ index: true, element: <ScheduleDashboard /> },
				{ path: 'needs-assigned', element: <NeedsAssigned /> },
				{ path: 'evv-compliance', element: <EvvCompliance /> }
			]
		}
	]
};
